<template>
  <textarea v-model="message" class="questionnaire-statement" placeholder="Toelichting.."></textarea>
</template>

<script>

export default {
  name: 'StatementField',

  watch: {
    message (newMessage) {
      this.$emit('updated', newMessage)
    }
  },

  methods: {

  },

  data () {
    return {
      message: null
    }
  }
}
</script>
